define('responsive-gameday/views/distributors/DataDistributor',['require','exports','module','message-service/message-service','./events/DistributionEvents','../Monitor/Events/SceneStateEvents','../Monitor/Events/ViewModelUpdateEvents','GameDayCore/GDModel/enums/events/EventTypes','../../utils/ui-log','./viewDistributors/BoxscoreDistributor','./viewDistributors/MatchupDistributor','./viewDistributors/PitchFXDistributor','./viewDistributors/FieldDistributor','./viewDistributors/PitchByPitchDistributor','./viewDistributors/PlayByPlayDistributor','./viewDistributors/InningPlaysDistributor','./viewDistributors/ScoringPlaysDistributor','./viewDistributors/ChyronDistributor'],function(require, exports, module) {
	var MessageService = require("message-service/message-service"),
		DistEvents = require("./events/DistributionEvents"),
		SceneEvents = require("../Monitor/Events/SceneStateEvents"),
		UpdateEvents = require("../Monitor/Events/ViewModelUpdateEvents"),
		CoreEvents = require("GameDayCore/GDModel/enums/events/EventTypes"),
		uilog = require("../../utils/ui-log");

	var BoxscoreDistributor = require("./viewDistributors/BoxscoreDistributor"),
		MatchupDistributor = require("./viewDistributors/MatchupDistributor"),
		PitchFXDistributor = require( "./viewDistributors/PitchFXDistributor" ),
		FieldDistributor = require( "./viewDistributors/FieldDistributor" ),
		PitchByPitchDistributor = require("./viewDistributors/PitchByPitchDistributor"),
		PlayByPlayDistributor = require("./viewDistributors/PlayByPlayDistributor"),
		InningPlaysDistributor = require("./viewDistributors/InningPlaysDistributor"),
		ScoringPlaysDistributor = require("./viewDistributors/ScoringPlaysDistributor"),
		ChyronDistributor = require("./viewDistributors/ChyronDistributor");

	var game = {};

	// *************************************** //
	//           < PUBLIC FUNCTIONS >          //
	// *************************************** //
	exports.init = function () {

		var boxDist = new BoxscoreDistributor(UpdateEvents.UPDATE_BOXSCORE),
			matchDist = new MatchupDistributor(UpdateEvents.UPDATE_MATCHUP),
			pitchFXDist = new PitchFXDistributor(UpdateEvents.UPDATE_PITCHFX),
			fieldDist = new FieldDistributor(UpdateEvents.UPDATE_FIELD_VIEW),
			pbpDist = new PitchByPitchDistributor(UpdateEvents.UPDATE_PITCHBYPITCH),
			playByPlayDist = new PlayByPlayDistributor(UpdateEvents.UPDATE_PLAYBYPLAY),
			scoringPlaysDist = new ScoringPlaysDistributor(UpdateEvents.UPDATE_SCORES),
			inningPlaysDist = new InningPlaysDistributor(UpdateEvents.UPDATE_INNING),
			chyronDist = new ChyronDistributor(UpdateEvents.UPDATE_CHYRON);

		// If loading a game that's already started, set a few things from the get go
		game = $.extend({}, GDC.getGameData());
		uilog.info('game data :: ', game);
		processUpdates();

		MessageService.addListener(CoreEvents.UPDATE, processUpdates);
		MessageService.addListener(CoreEvents.BEGIN_COMMERCIAL_BREAK, enterCommercialBreak);
		MessageService.addListener(CoreEvents.END_COMMERCIAL_BREAK, exitCommercialBreak);
	};

	// *************************************** //
	//          < PRIVATE FUNCTIONS >          //
	// *************************************** //
	/**
	 * Private Function processUpdates
	 *
	 * iterates through the newest events in the game data
	 * based on the event it will kick out a different event
	 */
	function processUpdates() {
		var evts = game.getNewGameEvents();
		uilog.info("Data Dist :: process updates", evts, game);
		for (var i = 0, l = evts.length; i < l; i++) {
			switch(evts[i]) {
				case "fullUpdate":
					MessageService.publish(DistEvents.UPDATE_ALL, game);
					break;
				case SceneEvents.NEW_BATTER:
				case SceneEvents.NEW_LEFT_HANDED_BATTER:
				case SceneEvents.NEW_LEFT_HANDED_BATTER_WITH_PITCHES:
				case SceneEvents.NEW_RIGHT_HANDED_BATTER:
				case SceneEvents.NEW_RIGHT_HANDED_BATTER_WITH_PITCHES:
					MessageService.publish(DistEvents.UPDATE_BATTER_NEW, game);
					break;

				default:
					// do nothing until you hear from me
					break;
			}
		}
	}

	function enterCommercialBreak() {

	}

	function exitCommercialBreak() {

	}
});
